function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 107,
    viewBox: "0 0 160 107",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8600"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8599"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 511",
    d: "M380.921 187H231.459a5.275 5.275 0 0 0-5.269 5.269v16.084a5.275 5.275 0 0 0 5.269 5.269h149.462a5.275 5.275 0 0 0 5.269-5.269v-16.084a5.275 5.275 0 0 0-5.269-5.269zm4.714 21.352a4.721 4.721 0 0 1-4.714 4.714H231.459a4.721 4.721 0 0 1-4.714-4.714v-16.083a4.721 4.721 0 0 1 4.714-4.714h149.462a4.721 4.721 0 0 1 4.714 4.714z",
    transform: "translate(-226.189 -185)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 512",
    d: "M380.921 333.894H231.459a5.275 5.275 0 0 1-5.269-5.269v-16.082a5.275 5.275 0 0 1 5.269-5.269h149.462a5.275 5.275 0 0 1 5.269 5.269v16.083a5.275 5.275 0 0 1-5.268 5.269zm-149.462-26.065a4.719 4.719 0 0 0-4.714 4.714v16.083a4.719 4.719 0 0 0 4.714 4.715h149.462a4.719 4.719 0 0 0 4.714-4.714v-16.084a4.719 4.719 0 0 0-4.714-4.714z",
    transform: "translate(-226.189 -267.284)",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 513",
    d: "M380.921 454.168H231.459a5.275 5.275 0 0 1-5.269-5.269v-16.082a5.275 5.275 0 0 1 5.269-5.269h149.462a5.275 5.275 0 0 1 5.269 5.269V448.9a5.275 5.275 0 0 1-5.268 5.269zM231.459 428.1a4.719 4.719 0 0 0-4.714 4.714V448.9a4.719 4.719 0 0 0 4.714 4.714h149.462a4.719 4.719 0 0 0 4.714-4.714v-16.083a4.719 4.719 0 0 0-4.714-4.715z",
    transform: "translate(-226.189 -349.569)",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 514",
    d: "M286.947 218.448a9.17 9.17 0 1 1 9.17-9.17 9.17 9.17 0 0 1-9.17 9.17z",
    transform: "translate(-261.482 -193.968)",
    style: {
      fill: "#0354a3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 515",
    d: "M456.38 243.233h-97.885a2.218 2.218 0 1 1 0-4.437h97.885a2.218 2.218 0 1 1 0 4.437z",
    transform: "translate(-315.187 -220.436)",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 516",
    d: "M424.484 213.384h-66a2.218 2.218 0 0 1 0-4.437h66a2.218 2.218 0 1 1 0 4.437z",
    transform: "translate(-315.184 -200.016)",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 517",
    d: "M286.947 338.721a9.17 9.17 0 1 1 9.17-9.17 9.17 9.17 0 0 1-9.17 9.17z",
    transform: "translate(-261.482 -276.251)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 518",
    d: "M456.38 363.507h-97.885a2.218 2.218 0 0 1 0-4.437h97.885a2.218 2.218 0 1 1 0 4.437z",
    transform: "translate(-315.187 -302.721)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 519",
    d: "M424.484 333.658h-66a2.218 2.218 0 0 1 0-4.437h66a2.218 2.218 0 0 1 0 4.437z",
    transform: "translate(-315.184 -282.299)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 520",
    d: "M286.947 458.995a9.17 9.17 0 1 1 9.17-9.17 9.17 9.17 0 0 1-9.17 9.17z",
    transform: "translate(-261.482 -358.536)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 521",
    d: "M456.38 483.781h-97.885a2.218 2.218 0 0 1 0-4.437h97.885a2.218 2.218 0 1 1 0 4.437z",
    transform: "translate(-315.187 -385.004)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 522",
    d: "M424.484 453.932h-66a2.218 2.218 0 0 1 0-4.437h66a2.218 2.218 0 1 1 0 4.437z",
    transform: "translate(-315.184 -364.583)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 395",
    d: "M297.89 222.692a1.049 1.049 0 0 1-.632-.21l-.011-.009-2.377-1.818a1.056 1.056 0 0 1 1.285-1.677l1.539 1.181 3.638-4.746a1.056 1.056 0 0 1 1.48-.2l-.022.032.023-.032a1.057 1.057 0 0 1 .2 1.48l-4.279 5.58a1.056 1.056 0 0 1-.84.411z",
    transform: "translate(-272.893 -204.156)",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNotifications);
export default __webpack_public_path__ + "static/media/no-notifications.ed18715bb58448a054193d911cf54176.svg";
export { ForwardRef as ReactComponent };